import React from 'react';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  fullPage?: boolean;
  inline?: boolean;
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  fullPage = false,
  inline = false,
  message,
}) => {
  const containerClasses = [
    'loading-spinner-container',
    fullPage ? 'fullPage' : '',
    inline ? 'inline' : '',
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClasses}>
      <div className={`loading-spinner ${size}`} />
      {message && <p className="loading-spinner-message">{message}</p>}
    </div>
  );
};

export default LoadingSpinner;
